import type { RouteRecordRaw } from 'vue-router'

export const AuthRoutes: RouteRecordRaw[] = [
  {
    path: 'login',
    name: 'Login',
    meta: {
      isPublic: true,
    },
    component: () => import('@/views/pages/Auth/Login/Index.vue'),
  },
  {
    path: 'logout',
    name: 'Logout',
    component: () => import('@/views/pages/Auth/Logout/Index.vue'),
  },
]
